import React from "react";
import BodyV2 from "./BodyV2";
import BodyLegacy from "./BodyLegacy";

export default function Body({ bannerData, ...rest }) {
  const isV2 = bannerData?.bannerStripDesktop || bannerData?.bannerStripMobile || bannerData?.bannerImageGridDesktop || bannerData?.bannerImageGridMobile || bannerData?.bannerBackgroundDesktopV2 || bannerData?.bannerBackgroundMobileV2;

  if (isV2) {
    return <BodyV2 bannerData={bannerData} {...rest} />;
  }

  return <BodyLegacy bannerData={bannerData} {...rest} />;
}
